import * as React from 'react';

export function IconSettings(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={21} height={19} {...props}>
            <path
                fillRule="evenodd"
                fill="#999"
                d="M10.5 12.667c-1.735 0-3.14-1.418-3.14-3.167 0-1.749 1.405-3.167 3.14-3.167s3.141 1.418 3.141 3.167c0 1.749-1.406 3.167-3.141 3.167zm8.872-.927l-1.471-.857c.082-.449.136-.909.136-1.383s-.054-.934-.136-1.383l1.471-.857a1.271 1.271 0 00.459-1.73l-1.256-2.194a1.25 1.25 0 00-1.716-.463l-1.486.864a7.515 7.515 0 00-2.361-1.395V1.267c0-.7-.562-1.267-1.256-1.267H9.244C8.55 0 7.988.567 7.988 1.267v1.074a7.537 7.537 0 00-2.361 1.396l-1.486-.864a1.25 1.25 0 00-1.716.463L1.169 5.53a1.272 1.272 0 00.459 1.73l1.471.857A7.674 7.674 0 002.963 9.5c0 .474.054.934.136 1.383l-1.471.857a1.272 1.272 0 00-.459 1.73l1.256 2.194a1.25 1.25 0 001.716.463l1.486-.864a7.496 7.496 0 002.361 1.395v1.075c0 .7.562 1.267 1.256 1.267h2.512c.694 0 1.256-.567 1.256-1.267v-1.074a7.518 7.518 0 002.361-1.396l1.486.864a1.25 1.25 0 001.716-.463l1.256-2.194a1.271 1.271 0 00-.459-1.73z"
            />
        </svg>
    );
}





// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/IconSettings.tsx